/* eslint-disable */
import config from '../../config'
import styles from './index.module.scss'
import PageTitle from '../../components/core/pageTitle'
import Breadcrumb from '../../components/core/breadcrumb'
import { useLocation, Link } from 'react-router-dom'
import { useLayoutEffect, useState, useContext, useEffect } from 'react'
import Helper from '../../utils/Helper'
import { PageContext } from '../../context/PageContextProvider'
import NewsAPI from '../../api/news'
import img from '../../assets/images/news.jpg'
import translate from '../../utils/translate.json'
import Loading from '../../components/pages/loading'

const NewsInternal = ({ className }) => {
  const { language } = useContext(PageContext)
  const location = useLocation()
  const [width, setWidth] = useState(false)
  const [data, setData] = useState([])
  const [crumbs, setCrumbs] = useState([])
  const [load, setLoad] = useState(false)
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) {
        setWidth(true)
        return
      }
      setWidth(false)
    }

    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  useEffect(() => {
    (async () => {

    const { data } = await NewsAPI.getWithId(location.pathname.split('/')[2])
    await setData(data)
    const text = await Helper.textLengthChecker(data.title?.[language] || data.title?.TR || data.title?.AZ || '', 16)
    await setCrumbs([
      {
        link: '/',
        text: {
          AZ: 'Ana Səhifə',
          ENG: 'Home',
          RU: 'Главная страница',
          TR: 'Ana Sayfa',
        },
      },
      {
        link: '/useful/news',
        text: {
          AZ: 'Xəbərlər',
          ENG: 'News',
          RU: 'Новости',
          TR: 'Haberler',
        },
      },
      {
        link: location.pathname,
        text: { AZ: text, ENG: text, RU: text, TR: text },
      },
    ])
    await setLoad(true)
  
    })();
  }, [])

  useEffect(() => {
    if (data && data.title) {
      const pageTitle = data.seoTitle?.[language] || data.seoTitle?.AZ || data.title?.[language] || data.title?.AZ || 'BPG Consulting'
      document.title = `${pageTitle} | BPG Consulting Centre`

      const metaDesc = data.metaDescription?.[language] || data.metaDescription?.AZ || ''
      if (metaDesc) {
        let metaTag = document.querySelector('meta[name="description"]')
        if (!metaTag) {
          metaTag = document.createElement('meta')
          metaTag.setAttribute('name', 'description')
          document.head.appendChild(metaTag)
        }
        metaTag.setAttribute('content', metaDesc)
      }

      const keywords = data.keywords?.[language] || data.keywords?.AZ || ''
      if (keywords) {
        let keywTag = document.querySelector('meta[name="keywords"]')
        if (!keywTag) {
          keywTag = document.createElement('meta')
          keywTag.setAttribute('name', 'keywords')
          document.head.appendChild(keywTag)
        }
        keywTag.setAttribute('content', keywords)
      }
    }
  }, [data, language])

  const see = {
    AZ: 'Hamısını gör',
    ENG: 'See All',
    RU: 'Увидеть все',
  }
  const posts = [
    {
      link: '/news/2',
      type: 'News',
      title: 'Kobe Steel plant that supplied plane components being checked',
      date: '31 July, 2022',
    },
    {
      link: '/news/3',
      type: 'News',
      title: 'Kobe Steel plant that supplied plane components being checked',
      date: '31 July, 2022',
    },
    {
      link: '/news/4',
      type: 'Event',
      title: 'Kobe Steel plant that supplied plane components being checked',
      date: '31 July, 2022',
    },
    {
      link: '/news/5',
      type: 'News',
      title: 'Kobe Steel plant that supplied plane components being checked',
      date: '31 July, 2022',
    },
  ]
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div>
        <Breadcrumb crumbs={crumbs} />
        <PageTitle>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ}</PageTitle>
        <div className={styles.content}>
          <div className={styles.post}>
            <div>
              <span>{new Date(data.date).toLocaleDateString()}</span>{' '}
              <span>{translate[`${data.newsType}`]?.[language] || translate[`${data.newsType}`]?.TR || translate[`${data.newsType}`]?.AZ || ''}</span>
            </div>
            {(() => {
              const defaultAddress = {
                AZ: 'Bakı, Azərbaycan',
                ENG: 'Baku, Azerbaijan',
                RU: 'Баку, Азербайджан',
                TR: 'Bakü, Azerbaycan',
              }
              const rawAddr = (typeof data.address === 'string' ? data.address : (data.address?.[language] || data.address?.AZ || ''))?.trim()
              const displayAddress = rawAddr || defaultAddress[language] || defaultAddress.TR || defaultAddress.AZ
              return (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  margin: '10px 0 16px 0',
                  color: 'var(--bpg-text-secondary, #64748b)',
                  fontSize: '15px',
                  fontWeight: 500,
                }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, color: 'var(--bpg-blue, #2563eb)' }}>
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <span>{displayAddress}</span>
                </div>
              )
            })()}
            <img
              src={
                data.photoLocation
                  ? data.photoLocation.startsWith('http')
                    ? data.photoLocation
                    : `${config.API_URL}${data.photoLocation.startsWith('/') ? '' : '/'}${data.photoLocation}`
                  : img
              }
              alt={data.title?.[language] || data.title?.TR || data.title?.AZ || ''}
            />
            <p
              dangerouslySetInnerHTML={{
                __html:
                  language === 'AZ'
                    ? data.description_az
                    : language === 'TR'
                    ? (data.description_tr || data.description_az)
                    : language === 'ENG'
                    ? data.description_eng
                    : (data.description_ru || data.description_az),
              }}
            />
          </div>
          {/* <div className={styles.all}>
            <div>{see[language]}</div>
            <div>
              {posts.map((item) => (
                <div>
                  <span>{item.type}</span>
                  <Link to={item.link}>
                    {width
                      ? Helper.textLengthChecker(item.title, 47)
                      : item.title}
                  </Link>
                  <span>{item.date}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default NewsInternal
